const styles = (theme) => ({
  root: {
    height: 50,
    letterSpacing: 1.25,
    minWidth: 138,
    borderRadius: 2,

    [theme.breakpoints.down('xs')]: {
      minWidth: 100,
    },
  },
  outlined: {
    color: theme.color.black,
    '&:hover': {
      color: theme.color.teal,
      borderColor: theme.color.teal,
      backgroundColor: theme.color.white,
    },
  },
  contained: {
    color: theme.color.white,
    backgroundColor: theme.color.black,
    borderColor: theme.color.black,
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: theme.color.teal,
    },
    '&.Mui-disabled': {
      color: theme.color.white,
    },
  },
});

export default styles;
